var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatePen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x9A\x99\xEF\xB8\x8F Icon / Variants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.988 1.42346C19.1178 0.514411 17.6644 0.538863 16.7864 1.41685L5.76823 12.4351C5.64268 12.5606 5.56404 12.7255 5.54545 12.9021L5.17602 16.4117C5.05609 17.3714 5.87867 18.194 6.83837 18.0741L10.348 17.7046C10.5246 17.6861 10.6894 17.6074 10.815 17.4819L21.8332 6.46362C22.7111 5.58563 22.7356 4.13226 21.8265 3.26204L19.988 1.42346ZM17.8827 2.5131C18.1748 2.22097 18.6287 2.24287 18.8705 2.49809L18.8851 2.5131L20.7369 4.36491L20.7519 4.37952C21.0071 4.62131 21.029 5.07524 20.7369 5.36737L19.5567 6.54759L16.7024 3.69333L17.8827 2.5131ZM15.6062 4.78958L18.4604 7.64385L9.91278 16.1916L6.72274 16.5274L7.05853 13.3373L15.6062 4.78958Z",
    className: "Icon-fill-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05033 4.6676C3.05033 3.95408 3.62875 3.37565 4.34226 3.37565H11.4623C11.8904 3.37565 12.2374 3.0286 12.2374 2.60049C12.2374 2.17237 11.8904 1.82532 11.4623 1.82532H4.34226C2.77252 1.82532 1.5 3.09785 1.5 4.6676V18.9077C1.5 20.4775 2.77253 21.75 4.34226 21.75H18.5823C20.152 21.75 21.4246 20.4775 21.4246 18.9077V11.7877C21.4246 11.3595 21.0775 11.0125 20.6494 11.0125C20.2213 11.0125 19.8742 11.3595 19.8742 11.7877V18.9077C19.8742 19.6212 19.2958 20.1997 18.5823 20.1997H4.34226C3.62875 20.1997 3.05033 19.6212 3.05033 18.9077V4.6676Z",
    className: "Icon-fill-color"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePen);
export default __webpack_public_path__ + "static/media/CreatePen.ddb6732dc3fe8c8b79cf8e84a6275fa6.svg";
export { ForwardRef as ReactComponent };